import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class ExceptionHandler implements ErrorHandler {
  handleError(error) {
    console.log(error);
  }
}
